<div class="d-flex justify-content-center">
  <ng-container *ngFor="let code of codes; let i=index;">
    <button
      class="language-selector btn btn-text-default font-lg fw-normal"
      [class.text-muted]="!isActive(code.value)"
      [class.active-language]="isActive(code.value)"
      (click)="changeLanguage(code.value)">{{code.label}}
    </button>

    <span class="spliter text-muted" *ngIf="!i">|</span>
  </ng-container>
</div>

